export enum OrderStatus {
  All = 0,
  Cancelled = 1,
  Expired = 2,
  Matched = 3,
  Open = 4,
  PartiallyMatched = 5,
  Rejected = 6,
  Suspended = 7,
}
